/*eslint-disable*/
import React from "react";

// reactstrap components
import { Container } from "reactstrap";

function DarkFooter() {
  return (
    <footer className="footer" data-background-color="black">
      <Container>
        <nav>
        </nav>
        <div className="copyright" id="copyright">
          <ul>
            <li>
              <a
                href="https://www.creative-tim.com?ref=nukr-dark-footer"
                target="_blank"
              >
                Facebook
              </a>
            </li>
            <li>
              <a
                href="http://presentation.creative-tim.com?ref=nukr-dark-footer"
                target="_blank"
              >
                Instagram
              </a>
            </li>
            <li>
              <a
                href="mailto:info@casaxamilpa.com"
                target="_blank"
              >
                Contacto
              </a>
            </li>
          </ul>
        </div>
      </Container>
    </footer>
  );
}

export default DarkFooter;
